var _g, _path, _path2, _path3, _rect, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 227,
    viewBox: "0 0 228 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 114,
    cy: 113.5,
    r: 112.851,
    fill: "#3D7FFE",
    fillOpacity: 0.44,
    stroke: "#EFF4FD",
    strokeWidth: 1.29714
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 114,
    cy: 113.5,
    r: 93.1781,
    fill: "#3D7FFE",
    fillOpacity: 0.44,
    stroke: "#DFEAFD",
    strokeWidth: 1.29714
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 114,
    cy: 113.5,
    r: 75.0181,
    fill: "#3D7FFE",
    fillOpacity: 0.14,
    stroke: "#D6E4FD",
    strokeWidth: 1.29714
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2783 77.9049C19.1167 77.2206 19.0312 76.507 19.0312 75.7733C19.0312 70.6691 23.1691 66.5312 28.2733 66.5312C29.7668 66.5312 31.1775 66.8855 32.4261 67.5145C34.129 62.0038 39.2638 58 45.3338 58C52.7939 58 58.8415 64.0476 58.8415 71.5077C58.8415 71.9948 58.8157 72.4759 58.7655 72.9496C63.5744 73.275 67.3744 77.2789 67.3744 82.1704C67.3744 87.2746 63.2366 91.4124 58.1324 91.4125V91.4126H17.2538C13.5238 91.4126 10.5 88.3888 10.5 84.6588C10.5 80.9287 13.5238 77.9049 17.2538 77.9049H19.2783Z",
    fill: "url(#paint0_linear_3206_64293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.339 57.2441C158.211 56.701 158.143 56.1347 158.143 55.5525C158.143 51.5027 161.426 48.2196 165.476 48.2196C166.661 48.2196 167.781 48.5007 168.771 48.9998C170.122 44.6274 174.196 41.4507 179.012 41.4507C184.932 41.4507 189.73 46.249 189.73 52.168C189.73 52.5546 189.709 52.9364 189.669 53.3124C193.485 53.5704 196.5 56.7473 196.5 60.6284C196.5 64.6783 193.217 67.9614 189.167 67.9614C189.167 67.9614 189.167 67.9614 189.167 67.9614V67.9614H156.733C153.774 67.9614 151.374 65.5622 151.374 62.6027C151.374 59.6432 153.774 57.2441 156.733 57.2441H158.339Z",
    fill: "url(#paint1_linear_3206_64293)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8531 137.709C64.6023 136.648 64.4695 135.541 64.4695 134.403C64.4695 126.495 70.8805 120.084 78.7889 120.084C81.1048 120.084 83.2923 120.633 85.228 121.61C87.866 113.071 95.8221 106.867 105.227 106.867C116.785 106.867 126.155 116.237 126.155 127.796C126.155 128.549 126.116 129.294 126.038 130.027C133.488 130.532 139.374 136.735 139.374 144.313C139.374 152.222 132.963 158.633 125.055 158.633C125.054 158.633 125.054 158.633 125.053 158.633V158.638H61.7172C55.938 158.638 51.2531 153.953 51.2531 148.174C51.2531 142.394 55.938 137.709 61.7172 137.709H64.8531Z",
    fill: "url(#paint2_linear_3206_64293)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 162.209,
    y: 154.252,
    width: 26.7016,
    height: 8.8029,
    rx: 4.40145,
    transform: "rotate(45 162.209 154.252)",
    fill: "#91B6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.441 169.047C177.613 167.875 179.512 167.875 180.684 169.047L197.548 185.911C200.283 188.646 200.283 193.08 197.548 195.815C194.813 198.55 190.378 198.55 187.643 195.815L170.779 178.951C169.608 177.78 169.608 175.88 170.779 174.709L176.441 169.047Z",
    fill: "#91B6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 124.5C174.5 150.153 153.486 171 127.5 171C101.514 171 80.5 150.153 80.5 124.5C80.5 98.8471 101.514 78 127.5 78C153.486 78 174.5 98.8471 174.5 124.5Z",
    fill: "url(#paint3_linear_3206_64293)",
    fillOpacity: 0.45,
    stroke: "#91B6FF",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3206_64293",
    x1: 38.9372,
    y1: 58,
    x2: 38.9372,
    y2: 91.4126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546804,
    stopColor: "#9BBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917449,
    stopColor: "#77A0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3206_64293",
    x1: 173.937,
    y1: 41.4507,
    x2: 173.937,
    y2: 67.9614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546804,
    stopColor: "#9BBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917449,
    stopColor: "#77A0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3206_64293",
    x1: 95.3136,
    y1: 106.867,
    x2: 95.3136,
    y2: 158.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546804,
    stopColor: "#9BBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917449,
    stopColor: "#77A0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3206_64293",
    x1: 107.217,
    y1: 77.3571,
    x2: 141.617,
    y2: 166.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D7FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E3FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.1c506ebb00c927faf4fd695f758bddea.svg";
export { ForwardRef as ReactComponent };